import {
  Flex,
  Form,
  Input,
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel
} from '@homebotapp/hb-react-component-catalog'
import { useCallback } from 'react'
import * as Sentry from '@sentry/browser'
import { defineMessages, useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { fetchAirDna } from '../../../../actions/airDna'
import { useCreateClientEvent } from '../../../../hooks'
import { selectParamsMap } from '../../../../store/selectors/airDna'
import { ClientEventName } from '../../../../api/gqlaxy/gql/generated/graphql'
import { ClientEventSource } from '../../../../api/gqlaxy/gql/generated/graphql'
import { BUYER_DIGEST_AIRDNA_MODULE } from '../../../../constants/tracking/trackingEventLocations/buyerDigestTrackingEventLocation'

export const MSG = defineMessages({
  address: {
    id: 'FormField.label.address',
    defaultMessage: 'Address'
  },
  zip: {
    id: 'AirDnaAddressForm.label.zipcode',
    defaultMessage: 'ZIP code'
  },
  search: {
    id: 'AirDna.address.search',
    defaultMessage: 'Search'
  },
  required: {
    id: 'AirDna.input.required',
    defaultMessage: 'This field is required'
  },
  zipInvalid: {
    id: 'AirDna.input.zipInvalid',
    defaultMessage: 'Invalid ZIP code'
  }
})

export interface AirDnaAddressFormProps {
  stateKey: string
}

export const AirDnaAddressForm = ({ stateKey }: AirDnaAddressFormProps) => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const params = useSelector(selectParamsMap)[stateKey]
  const { mutateAsync: createClientEvent } = useCreateClientEvent({ disableErrorPrompts: true })

  const createUsedShortTermRentalsCalculatorEvent = useCallback(() => {
    createClientEvent({
      clientEventInput: {
        eventSource: ClientEventSource.Calculators,
        eventName: ClientEventName.UsedShortTermRentalCalculator
      }
    })
  }, [createClientEvent])

  const handleSubmit = data => {
    try {
      createUsedShortTermRentalsCalculatorEvent()
      dispatch(fetchAirDna(stateKey, { address: data?.address }))
    } catch (err) {
      Sentry.captureException(err)
    }
  }

  return (
    <Form onSubmit={data => handleSubmit(data)}>
      {({ formState: { errors } }) => (
        <Flex gap={4} padding={4} align='flex-end' justify='space-between' direction={['column', null, 'row']}>
          <FormControl isInvalid={!!errors?.address}>
            <FormLabel>{intl.formatMessage(MSG.address)}</FormLabel>
            <Input
              name='address'
              defaultValue={params?.address}
              rules={{
                required: {
                  value: true,
                  message: intl.formatMessage(MSG.required)
                }
              }}
              tracking={{
                guid: 'uMqgiV8YM7zNdyviKGAAfU',
                ui_context: BUYER_DIGEST_AIRDNA_MODULE,
                descriptor: MSG.address.defaultMessage
              }}
            />
            <FormErrorMessage>{errors?.address?.message?.toString()}</FormErrorMessage>
          </FormControl>
          <Button
            type='submit'
            flex='1 0 auto'
            width={['100%', null, 'auto']}
            tracking={{
              guid: 'q4MqpUt3tPCxEn1EA6YVWg',
              descriptor: MSG.search.defaultMessage,
              ui_context: BUYER_DIGEST_AIRDNA_MODULE
            }}
          >
            {intl.formatMessage(MSG.search)}
          </Button>
        </Flex>
      )}
    </Form>
  )
}
